import { render, staticRenderFns } from "./search-profession.vue?vue&type=template&id=3568117b&scoped=true&"
import script from "./search-profession.vue?vue&type=script&lang=js&"
export * from "./search-profession.vue?vue&type=script&lang=js&"
import style0 from "./search-profession.vue?vue&type=style&index=0&id=3568117b&scoped=true&lang=less&"
import style1 from "./search-profession.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3568117b",
  null
  
)

export default component.exports